import { useState } from "react";

// hook for fetch handle open close of modal
export function useHandleModal(setPage: any) {
  // state
  const [openSearch, setOpenSearch] = useState(false);

  const onOpenSearch = () => {
    setOpenSearch(true);
  };

  const onCloseSearch = () => {
    setPage(1);
    setOpenSearch(false);
  };

  // retrun from hook
  return {
    openSearch,
    onOpenSearch,
    onCloseSearch,
  };
}
